import {
  coerceComposeArchetypeDraft,
  type ComposeArchetypeDraft,
} from "@/lib/manufacturing/composeArchetypeDraft";
import {
  emptyArchetype,
  normalizeComposeSlots,
  type ComposeArchetype,
} from "./types";

export type { ComposeArchetypeDraft };

export { coerceComposeArchetypeDraft };

/** Merge coerced draft into an archetype form (user edits win when fields already set). */
export function applyArchetypeDraftToForm(
  current: ComposeArchetype,
  draft: ComposeArchetypeDraft,
  opts?: { overwrite?: boolean },
): ComposeArchetype {
  const overwrite = opts?.overwrite === true;
  const base = emptyArchetype({ ...current });
  const slots = normalizeComposeSlots(draft.slots);
  return {
    ...base,
    seriesName: overwrite || !base.seriesName ? draft.seriesName || base.seriesName : base.seriesName,
    seriesCode: overwrite || !base.seriesCode ? draft.seriesCode || base.seriesCode : base.seriesCode,
    namingPattern: draft.namingPattern || base.namingPattern,
    sizesRaw:
      overwrite || !base.sizesRaw.trim() ? draft.sizes.join(", ") : base.sizesRaw,
    styles:
      overwrite || base.styles.length === 0
        ? draft.styles.length
          ? draft.styles
          : base.styles
        : base.styles,
    slots: slots.length ? slots : base.slots,
    skuListRaw:
      overwrite || !base.skuListRaw.trim()
        ? draft.skuList.map((s) => `${s.code} | ${s.name}`).join("\n")
        : base.skuListRaw,
  };
}
